export const DISPATCH_GUEST_DATA = 'DISPATCH_GUEST_DATA';

export const BASE = 'BASE/';

export const CLEAR_GUEST_DATA = 'CLEAR_GUEST_DATA';

export const ATTEMPT_LOGIN_SUCCESS = `${BASE} ATTEMPT_LOGIN_SUCCESS`;

export const BRAND_GUEST_LOGIN_SUCCESS = `${BASE} BRAND_GUEST_LOGIN_SUCCESS`;

export const DISPATCH_AUTH_TOKEN = `${BASE} DISPATCH_AUTH_TOKEN`;

export const DISPATCH_SIGNIN_DATA = `${BASE} DISPATCH_SIGNIN_DATA`;

export const CREATE_BRAND_GUEST = 'CREATE_BRAND_GUEST';

export const DISPATCH_CACHE_LOGIN_DATA = 'DISPATCH_CACHE_LOGIN_DATA';

export const SET_IS_GUEST_MODE = 'SET_IS_GUEST_MODE';

export const DISPATCH_BRAND_CONSENT_CONFIG = 'DISPATCH_BRAND_CONSENT_CONFIG';